<div id="scrollable-div" class="bradcrumbs-wrapper d-flex">
  <div id="content">
    <p *ngIf="breadcrumbsObj?.line" class="breadcrumb" (click)="redirectLine()" >{{breadcrumbsObj.line.name}} </p>
    <p *ngIf="breadcrumbsObj?.family" class="breadcrumb" (click)="redirectFamily()">{{breadcrumbsObj.family.name}}</p>
  </div>
</div>
